import React from 'react'
import Adminanalytics from '../Admin/Adminanalytics'
import { useSelector } from 'react-redux'
import OldOverview from './OldOverview'
import { adminAnalyticsUsers } from '../../utils/constants'

export default function Overview() {
  const {user,isAdmin} = useSelector((state)=>state.auth)
  return (
    <div>
      {
        (adminAnalyticsUsers.includes(user?.email) || isAdmin) ?<Adminanalytics/> :<OldOverview/>
      }
    </div>
  )
}
